import { makeBetterEnum } from './betterEnum';

export const EmissionsModelStableKind = makeBetterEnum('core', 'customer');

export type EmissionsModelStableKind =
  (typeof EmissionsModelStableKind)[keyof typeof EmissionsModelStableKind];

export const EmissionsModelStableScope = makeBetterEnum('partial', 'full');

export type EmissionsModelStableScope =
  (typeof EmissionsModelStableScope)[keyof typeof EmissionsModelStableScope];

export const EmissionsModelMatcherKind = makeBetterEnum('Published', 'Draft');

export type EmissionsModelMatcherKind =
  (typeof EmissionsModelMatcherKind)[keyof typeof EmissionsModelMatcherKind];

export const EmissionsModelVersionKind = makeBetterEnum('Published', 'Draft');

export type EmissionsModelVersionKind =
  (typeof EmissionsModelVersionKind)[keyof typeof EmissionsModelVersionKind];

export const EmissionsModelReleaseLifecyclePhase = makeBetterEnum(
  // Alert! Removing/renaming these values may require a database migration
  'Alpha',
  'Beta',
  'Current',
  'LTS',
  'Maintenance',
  'EndOfLife'
);

export type EmissionsModelReleaseLifecyclePhase =
  (typeof EmissionsModelReleaseLifecyclePhase)[keyof typeof EmissionsModelReleaseLifecyclePhase];

export type EmissionsModelListTab =
  | 'all'
  | 'main'
  | 'demo'
  | 'autogenerated'
  | 'sandbox';

export function isEmissionsModelListTab(
  tab: string | null
): tab is EmissionsModelListTab {
  return (
    tab === 'all' ||
    tab === 'main' ||
    tab === 'demo' ||
    tab === 'autogenerated' ||
    tab === 'sandbox'
  );
}
